import { useEffect, useRef } from 'react';
import { useCreateNotificationForMyselfMutation } from '@/store/api';

export function useFirstTradeAchievementNotification({
	showFirstTradeModal,
	isUserHasTrades,
	userEmail,
}: {
	showFirstTradeModal: boolean;
	isUserHasTrades: boolean;
	userEmail: string | undefined;
}) {
	const notifiedRef = useRef(new Set<string>());
	const [createNotificationForMyself] = useCreateNotificationForMyselfMutation();

	useEffect(() => {
		if (!showFirstTradeModal || isUserHasTrades || !userEmail) return;
		if (notifiedRef.current.has('firstPrediction')) return;
		notifiedRef.current.add('firstPrediction');
		createNotificationForMyself({
			title: 'Achievement Unlocked',
			message: "First prediction locked in! You're officially in the game!",
		})
			.unwrap()
			.catch((err) => {
				console.error('First-trade achievement notification failed:', err);
			});
	}, [isUserHasTrades, showFirstTradeModal, userEmail, createNotificationForMyself]);
}
